import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { CheckboxInput } from '@ztechapps/webui.input'
import { useContext } from './Context'
import { HorizontalStack } from '@ztechapps/webui.util'

export const CalendarEventCheckbox = () => {
  const { groupedEvents, setDisplayEvents } = useContext()

  const [checkboxValues, setCheckboxValues] = React.useState({})

  const [newGroupedEvents, setNewGroupedEvents] = React.useState<any>()
  React.useEffect(() => {
    setNewGroupedEvents(groupedEvents)
    if (groupedEvents) {
      const ss = {}
      for (const key of Object.keys(groupedEvents)) {
        ss[key] = {
          value: groupedEvents[key]?.[0]?.extendedProps?.showDefault ?? false,
          color: groupedEvents[key]?.[0]?.extendedProps?.color ?? 'primary',
        }
      }
      setCheckboxValues(ss)
    }
  }, [groupedEvents])

  React.useEffect(() => {
    const newValues = { ...newGroupedEvents }
    for (const groupItem of Object.entries(checkboxValues)) {
      const [key, value]: [string, any] = groupItem
      newValues[key] = value?.value === true ? newGroupedEvents[key] : []
    }
    let result = []
    for (const newValue of Object.values(newValues)) {
      result = result.concat(newValue)
    }

    setDisplayEvents(result)
  }, [checkboxValues, newGroupedEvents, setDisplayEvents])

  return (
    <HorizontalStack gap={2}>
      {Object?.entries(checkboxValues)?.map(([key, value]: [string, any]) => {
        const keyName = !isEmpty(key) ? key : 'Events'

        return (
          <CheckboxInput
            key={keyName}
            className={`checkbox-${value?.color}`}
            value={value?.value}
            label={keyName}
            name={key}
            onChange={(e) => {
              const newCheckboxValues = { ...checkboxValues }
              newCheckboxValues[key] = {
                ...newCheckboxValues[key],
                value: e,
              }
              setCheckboxValues(newCheckboxValues)
            }}
          />
        )
      })}
    </HorizontalStack>
  )
}
